import store from "../store";
import Constants from "../config/constants";
import { serviceGetVendorsRecommendationApproval } from "../services/VendorApproval.service";

export const FETCH_INIT = "FETCH_INIT_VENDOR_RECOMMENDATION_APPROVAL";
export const FETCHED = "FETCHED_VENDOR_RECOMMENDATION_APPROVAL";
export const FETCHED_FAIL = "FETCHED_FAIL_VENDOR_RECOMMENDATION_APPROVAL";
export const FETCHED_FILTER = "FETCHED_FILTER_VENDOR_RECOMMENDATION_APPROVAL";
export const FETCH_NEXT = "FETCH_NEXT_VENDOR_RECOMMENDATION_APPROVAL";
export const FILTER = "FILTER_VENDOR_RECOMMENDATION_APPROVAL";
export const RESET_FILTER = "RESET_FILTER_VENDOR_RECOMMENDATION_APPROVAL";
export const SET_SORTING = "SET_SORTING_VENDOR_RECOMMENDATION_APPROVAL";
export const SET_FILTER = "SET_FILTER_VENDOR_RECOMMENDATION_APPROVAL";
export const SET_PAGE = "SET_PAGE_VENDOR_RECOMMENDATION_APPROVAL";
export const CHANGE_PAGE = "CHANGE_PAGE_VENDOR_RECOMMENDATION_APPROVAL";
export const CHANGE_STATUS = "CHANGE_STATE_VENDOR_RECOMMENDATION_APPROVAL";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_VENDOR_RECOMMENDATION_APPROVAL";
export const CREATE_DATA = "CREATE_VENDOR_RECOMMENDATION_APPROVAL";
export const UPDATE_DATA = "UPDATE_VENDOR_RECOMMENDATION_APPROVAL";
export const DELETE_ITEM = "DELETE_VENDOR_RECOMMENDATION_APPROVAL";

export function actionFetchVendorRecommendationApproval(
    index = 1,
    sorting = {},
    filter = {}
) {
    const request = serviceGetVendorsRecommendationApproval({
        index,
        row: sorting.row,
        order: sorting.order,
        ...filter,
    });
    return (dispatch) => {
        dispatch({ type: FETCH_INIT, payload: null });
        request.then((data) => {
            dispatch({ type: SET_FILTER, payload: filter });
            dispatch({ type: SET_SORTING, payload: sorting });
            if (!data.error) {
                dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({ type: CHANGE_PAGE, payload: index - 1 });
                }
            } else {
                dispatch({ type: FETCHED_FAIL, payload: null });
            }
        });
    };
}

export function actionChangePageVendorRecommendationApproval(page) {
    return (dispatch) => {
        dispatch({ type: CHANGE_PAGE, payload: page });
    };
}

export function actionFilterVendorRecommendationApproval(value) {
    const request = null;
    return (dispatch) => {
        dispatch({ type: FETCH_INIT, payload: null });
        request.then((data) => {
            dispatch({ type: FILTER, payload: data });
            dispatch({ type: FETCHED, payload: null });
        });
    };
}
export function actionResetFilterVendoRecommendationApprovalr() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionSetPageVendorRecommendationApproval(page) {
    const stateData = store.getState().vendors_recommendation_approval;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data;
    const serverPage = stateData.serverPage;

    if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
        store.dispatch(
            actionFetchVendorRecommendationApproval(serverPage + 1, sortingData, {
                query,
                query_data: queryData,
            })
        );
    }

    console.log(currentPage, totalLength);
    return {
        type: CHANGE_PAGE,
        payload: page,
    };
}
